export enum TaxType {
Empty,
WithHeld,
Fees,
OtherTax,
StampDuty,
Deduction,
}
